import * as React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import AiStudio from './media/AiStudio.svg';
import Azure from './media/Azure.svg';
import CopilotForSecurity from './media/CopilotForSecurity.svg';
import CopilotStudio from './media/CopilotStudio.svg';
import Defender from './media/Defender.svg';
import DevOps from './media/DevOps.svg';
import Entra from './media/Entra.svg';
import Fabric from './media/Fabric.svg';
import FoundersHub from './media/FoundersHub.svg';
import GitHub from './media/GitHub.svg';
import Intune from './media/Intune.svg';
import Microsoft365Admin from './media/Microsoft365Admin.svg';
import PowerPlatform from './media/PowerPlatform.svg';
import Priva from './media/Priva.svg';
import Purview from './media/Purview.svg';
import { MicrosoftCloudItem } from './MicrosoftCloudItem';

const menuItems = [
  {
    title: 'AI Studio',
    icon: AiStudio,
    link: 'https://aka.ms/AIStudioWaffle',
  },
  {
    title: 'Azure',
    icon: Azure,
    link: 'https://aka.ms/AzureWaffle',
  },
  {
    title: 'Copilot for Security',
    icon: CopilotForSecurity,
    link: 'https://aka.ms/SecurityCopilotWaffle',
  },
  {
    title: 'Copilot Studio',
    icon: CopilotStudio,
    link: 'https://aka.ms/CopilotStudioWaffle',
  },
  {
    title: 'Defender',
    icon: Defender,
    link: 'https://aka.ms/DefenderWaffle',
  },
  {
    title: 'DevOps',
    icon: DevOps,
    link: 'https://aka.ms/DevOpsWaffle',
  },
  {
    title: 'Entra',
    icon: Entra,
    link: 'https://aka.ms/EntraWaffle',
  },
  {
    title: 'Fabric',
    icon: Fabric,
    link: 'https://aka.ms/FabricWaffle',
  },
  {
    title: 'Founders Hub',
    icon: FoundersHub,
    link: 'https://aka.ms/FoundersHubWaffle',
    isSelected: true,
  },
  {
    title: 'GitHub',
    icon: GitHub,
    link: 'https://aka.ms/GitHubWaffle',
  },
  {
    title: 'Intune',
    icon: Intune,
    link: 'https://aka.ms/intuneWaffle',
  },
  {
    title: 'Microsoft 365 Admin',
    icon: Microsoft365Admin,
    link: 'https://aka.ms/M365Waffle',
  },
  {
    title: 'Power Platform',
    icon: PowerPlatform,
    link: 'https://aka.ms/PowerPlatformWaffle',
  },
  {
    title: 'Priva ',
    icon: Priva,
    link: 'https://aka.ms/PrivaWaffle',
  },
  {
    title: 'Purview',
    icon: Purview,
    link: 'https://aka.ms/PurviewWaffle',
  },
];

export const MicrosoftCloudMenu = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.textWrapper}>
        <div className={classes.text}>Microsoft Cloud</div>
      </div>
      <div className={classes.itemsWrapper}>
        {menuItems.map((item) => (
          <MicrosoftCloudItem
            key={item.title}
            name={item.title}
            icon={item.icon}
            url={item.link}
            isSelected={item.isSelected}
          />
        ))}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    top: '76px',
    left: '11px',
    width: '511px',
    ...shorthands.padding(0, '8px', '12px', '8px'),
    background: tokens.colorNeutralBackground1,
    // eslint-disable-next-line
    boxShadow: '0px 26px 58px rgba(0, 0, 0, 0.22)',
    borderRadius: tokens.borderRadiusXLarge,
    zIndex: 1000,
  },
  itemsWrapper: {
    gap: '2px',
    flexWrap: 'wrap',
  },
  text: {
    height: tokens.spacingVerticalXXXL,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    display: 'flex',
    alignItems: 'center',
  },
  textWrapper: { ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalXXL) },
});
